// extracted by mini-css-extract-plugin
export var sidebarSection = "sidebar-module--sidebar-section--nqQOy";
export var sidebarHeading = "sidebar-module--sidebar-heading--2Z4IJ";
export var sidebarItem = "sidebar-module--sidebar-item--2q4-I";
export var sidebarItemActive = "sidebar-module--sidebar-item--active--19pjR";
export var sidebarLink = "sidebar-module--sidebar-link--1_SOR";
export var sidebarLinkActive = "sidebar-module--sidebar-link--active--3ZMrq";